import { Flex } from "antd";
import { FC } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

import { CheckoutDiffItem, RemainingResolution } from "./CheckoutCard.types";
import { DiffItem } from "./DiffItem";

interface CheckoutCardContentProps {
    hasLoadError: boolean;
    hasAnyDiffs: boolean;
    hasRemainingConflicts: boolean;
    allRemainingsResolved: boolean;
    diffItems: CheckoutDiffItem[];
    remainingResolutions: Record<string, RemainingResolution | undefined>;
    onResolutionChange: (barcode: string, value: RemainingResolution) => void;
}

export const CheckoutCardContent: FC<CheckoutCardContentProps> = ({
    hasLoadError,
    hasAnyDiffs,
    hasRemainingConflicts,
    allRemainingsResolved,
    diffItems,
    remainingResolutions,
    onResolutionChange,
}) => {
    if (hasLoadError) {
        return (
            <PrimaryText type="danger">Не вдалося завантажити дані</PrimaryText>
        );
    }

    if (!hasAnyDiffs) {
        return (
            <PrimaryText type="secondary">
                Для цього замовлення немає змін цін або конфліктів по залишках
            </PrimaryText>
        );
    }

    return (
        <Flex vertical gap={12}>
            {diffItems.map((item) => (
                <DiffItem
                    key={item.barcode}
                    item={item}
                    resolution={remainingResolutions[item.barcode]}
                    onResolutionChange={onResolutionChange}
                />
            ))}

            {hasRemainingConflicts && !allRemainingsResolved && (
                <PrimaryText textColor="error">
                    Щоб перенести замовлення, потрібно вибрати дію для всіх
                    товарів із нестачею залишків
                </PrimaryText>
            )}
        </Flex>
    );
};
